import { Container, Point, Texture } from "pixi.js";
import { PiggyResourcePackage } from "../../resources/PiggyResourcePackage";
import { IPiggyController } from "../../controller/IPiggyController";
import { BigPiggyComponent } from "../bigpiggy/BigPiggyComponent";

export class PiggyContentView extends Container {
    protected readonly piggyResources: PiggyResourcePackage;
    protected readonly piggyController: IPiggyController;

    protected bigPiggy: BigPiggyComponent;

    public constructor(
        piggyResources: PiggyResourcePackage,
        piggyController: IPiggyController,
        piggyTexture: Texture,
        piggyInfoPos: Point
    ) {
        super();
        this.piggyResources = piggyResources;
        this.piggyController = piggyController;
        this.bigPiggy = new BigPiggyComponent(this.piggyController, this.piggyResources, piggyTexture, piggyInfoPos);
        this.bigPiggy.position.set(0, 212);
        this.addChild(this.bigPiggy);
    }
}
